<template>
  <el-container class="layout">
    <el-header class="layout-header">
      <Header />
    </el-header>
    <el-container class="layout-main">
      <el-aside class="layout-left" :width="width">
        <SideBar />
      </el-aside>
      <div class="layout-right">
        <!-- <transition name="fade-transform" mode="out-in"> -->
        <!-- <keep-alive exclude="DataComplaintStart"> -->
        <router-view
          v-loading="$store.state.app.fullLoading"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="$store.state.app.loadingText"
        ></router-view>
        <!-- </keep-alive> -->
        <!-- </transition> -->
      </div>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Header from './components/header';
import SideBar from './components/side-bar';

export default {
  name: 'layout',
  components: {
    Header,
    SideBar,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['isCollapse']),
    width() {
      return this.isCollapse ? '64px' : '200px';
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #ebeef5;

  .layout-header {
    height: 60px;
    padding: 0;
  }

  .layout-main {
    flex: 1;
    overflow: hidden;
  }

  .layout-left {
    width: 200px;
    transition: width 0.3s;
    box-shadow: 0px 0px 4px 1px rgba(0, 0, 0, 0.1);
  }

  .layout-right {
    flex: 1;
    overflow-x: hidden;
    overflow-y: auto;
    // overflow: hidden;
  }
}
</style>
